module.exports = ".size{width:80px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/product-qty/product-qty.component.scss
// module id = 1018
// module chunks = 0